import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import { Pagination } from "semantic-ui-react";
import { UserFreeSalasList } from "../UserFreeSalasCmp";
import "./UserFreeGridCmp.scss";

const ResponsiveGridLayout = WidthProvider(Responsive);

// Definimos un layout inicial ajustado (nota: el valor de y para pagination se ha cambiado para que no se solape)
const initialLayout = [
  { i: "salasList", x: 0, y: 0, w: 12, h: 19 },
  { i: "pagination", x: 0, y: 19, w: 12, h: 2 },
];

export function UserFreeGridCmp(props) {
  const {
    user,
    accessToken,
    page,
    setPage,
    totalPages,
    setTotalPages, // Lo usamos para actualizar desde el listado
    reload,
    onReload,
  } = props;

  return (
    <ResponsiveGridLayout
      className="userFree-salas-grid"
      layouts={{ lg: initialLayout }}
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
      cols={{ lg: 12, md: 10, sm: 8, xs: 4, xxs: 2 }}
      rowHeight={30}
      margin={[10, 10]}
      draggableCancel=".ui.button, .ui.pagination.menu, .ui.pagination.menu *, .btn-filter, .btn-subfilter"
    >
      {/* Área central: Listado de Salas */}
      <div key="salasList" style={{ backgroundColor: "#fff", padding: "1rem", overflowY: "auto" }}>
        <UserFreeSalasList
          accessToken={accessToken}
          user={user}
          currentPage={page}
          onPageChange={setPage}
          onTotalPagesChange={setTotalPages}  // Actualiza totalPages
          reload={reload}
          onReload={onReload}
        />
      </div>

      {/* Área inferior: Paginación */}
      <div key="pagination" style={{ backgroundColor: "#f9fafc", padding: "1rem" }}>
        <Pagination
          totalPages={totalPages}
          activePage={page}
          onPageChange={(e, { activePage }) => setPage(activePage)}
        />
      </div>
    </ResponsiveGridLayout>
  );
}
